<template>
  <div class="techinical-assesment-container">
    <strong class="screen-title"><translate>TECHINICAL_ASSESSMENT</translate></strong>
    <crud-layout ref="crudLayout" :name="Teste" :interface="interface" :id="id" :params="params" :page="page"
      :page-detail="pageDetail">
      <template slot="table" slot-scope="dataTable">
        <data-table ref="jtDataTable" class="table-crud" v-bind="dataTable" :columnEdit="paintCell"
          @selection="selection" @action-button="(button, params) => actionButtonPageSlot(button, params, this)"
          @show-message="(type, message) => { $refs.crudLayout.showMessage(type, message, this) }" @click-row="clickRow">
        </data-table>
      </template>
    </crud-layout>
    <footer v-show="landfillLaboratoryProcedure != null" class="row full-width q-col-gutter-lg justify-center q-py-md">
      <strong class="footer-content"><translate>REFERENCE_PROCCESS</translate>: {{ landfillLaboratoryProcedure }}</strong>
    </footer>
    <consent-letter-modal v-if="showConsentLetterModal" ref="consentLetterModal" :params="consentLetterParams"
      :showConsentLetterModal="showConsentLetterModal" @input="handleCloseModalConsentLetter" />
  </div>
</template>
<script>

import { Component, Vue } from 'vue-property-decorator'
import { JtCrud } from 'jtech-webcomps'
import TechnicalAssessmentPage from './TechnicalAssessmentPage'
const { CrudLayout } = JtCrud
import { repository } from 'jtech'
import eventCommunicationHandle from './CommunicationState.js'
import departaments from './departaments'
import DataTable from './DataTable'
import PageDetail from './PageDetail.vue'
import ConsentLetterModal from './ConsentLetterModal.vue'
import TechinicalAssementRepository from './TechinicalAssementRepository'
import ConsentLetterModel from '../consent-letter/consent-letter/ConsentLetterModel'
@Component({
  name: 'TechnicalAssessment',
  components: { CrudLayout, TechnicalAssessmentPage, DataTable, ConsentLetterModal },
  mixins: [DataTable],
  props: {
    id: String,
    interface: String,
    name: String,
    params: Object
  }
})
class TechnicalAssessment extends Vue {
  consentLetterParams = {}
  state = ConsentLetterModel.getInstance()
  landfillLaboratoryProcedure = null
  showConsentLetterModal = false

  mounted () {
    this.$refs.crudLayout.onButton('icAlterar', this.editTechinicalAssesmentLaboratory)
    this.$refs.crudLayout.onButton('btCreateConsentLetter', this.openConsentLetterModal)
    eventCommunicationHandle.$on('close-page', this.closePage)
    eventCommunicationHandle.$on('page-params', this.handlePageParams)
  }

  handleCloseModalConsentLetter (param) {
    this.showConsentLetterModal = param
    eventCommunicationHandle.$emit('refresh-page-search')
  }

  handlePageParams (params) {
    this.landfillLaboratoryProcedure = params
  }

  async actionButtonPageSlot (button, params, page) {
    if (button.name == 'btCreateConsentLetter') {
      // se der errado o a carta o ponto é esse
      if (params.technicalAssessmentResidueId) {
        const {
          data
        } = await TechinicalAssementRepository.technicalAssessmentResidues(params.technicalAssessmentResidueId)
        const {
          landfill,
          client,
          quantityGeneration,
          generator,
          residue,
          residueName,
          generatorName,
          consentLetterResidueDescription
        } = data

        const consentLetterItens = {
          quantityGeneration,
          generator,
          residue,
          residueName,
          generatorName,
          consentLetterResidueDescription
        }
        this.state.setLandfill(landfill)
        this.state.setClient(client)
        this.state.setConsentLetterItens(consentLetterItens)

        this.state.setTechinicalAssessmentId(params.techinicalAssessmentId)
        this.openConsentLetterModal(params)
      }
    } else if (button.name == 'icAlterar') {
      this.editTechinicalAssesmentLaboratory(params)
    } else {
      this.$refs.crudLayout.actionButton(button, params, page)
    }
  }

  openConsentLetterModal (row) {
    this.showConsentLetterModal = true
    this.consentLetterParams = { id: row.technicalAssessmentResidueId }
  }

  get pageDetail () {
    return PageDetail
  }

  closePage (page) {
    this.$refs.crudLayout.removePage(page)
  }

  async editTechinicalAssesmentLaboratory (row) {
    const departament = row.departament
    const alterInterfaceName = this.getAlterInterfaceName(departament)
    const commercialForm = await repository.resolve(alterInterfaceName, { idAcaoGrid: row.id })
    commercialForm[0].dadosForm.laboratyId = row.laboratyId
    commercialForm[0].dadosForm.technicalAssesmentResidueCommercialId = row.id
    if (departament == departaments.LABORATORY) {
      commercialForm[0].inputs.forEach(input => {
        input.readonly = true
      })
      commercialForm[0].isLaboratory = true
    }

    if (departament == departaments.COMMERCIAL) {
      commercialForm[0].isCommercialChange = true
    }

    this.$refs.crudLayout.addPage({
      label: this.$gettext('UPDATE_REGISTRATION'),
      forms: commercialForm,
      params: commercialForm[0].dadosForm,
      component: this.page,
      flClose: true
    })
  }

  getAlterInterfaceName (departament) {
    let interfaceName = ''
    switch (departament) {
      case 1:
        interfaceName = 'technicalAssessmentResidueCommercial.alterWithButtons'
        break

      case 4:
        interfaceName = 'technicalAssessmentResidueCommercial.alterar'
        break

      default:
        throw 'the getAlterInterface() method expected 1 parameter'
    }
    return interfaceName
  }

  get nmInterface () {
    return this.interface
  }

  get page () {
    return TechnicalAssessmentPage
  }

  paintCell (row) {
    return this.handleStatusColumn(row)
  }

  handleStatusColumn (row) {
    switch (row.col.name) {
      case 'status':
        if (row.col.value.toLowerCase() == 'aprovado') {
          return this.createStatusColumn(row.col.value.toLowerCase(), this.$gettext('APPROVED'), '#97BF0D')
        } else if (row.col.value.toLowerCase() == 'reprovado') {
          return this.createStatusColumn(row.col.value.toLowerCase(), this.$gettext('REPROVED'), '#E95F47')
        } else if (row.col.value.toLowerCase() == 'comercial') {
          return this.createStatusColumn(row.col.value.toLowerCase(), this.$gettext('TECHINICAL_ASSESSMENT_COMMERCIAL'), '#475DE9')
        } else if (row.col.value.toLowerCase() == 'laboratorial') {
          return this.createStatusColumn(row.col.value.toLowerCase(), this.$gettext('TECHINICAL_ASSESSMENT_LABORATORY'), '#D4BE00')
        }
        break
      default:
        return false
    }
  }

  createStatusColumn (row, dataToolTip, detailColor) {
    return `
  <div style="display: flex; align-items: center; width: 150px; justify-content: space-between;">
    <span style="color:${detailColor}; font-weight:500" class="q-pa-sm">${row.toUpperCase()}</span>
    <div style="padding: 8px" class="tooltip" data-tooltip="${dataToolTip}">
      <span style="
        display: inline-block;
        height: 10px;
        width: 10px;
        border-radius: 50%;
        background-color: ${detailColor};" >
      </span>
    </div>
  </div> `
  }
}
export default TechnicalAssessment
</script>
<style lang="stylus" >
.techinical-assesment-container {
    margin-top: 50px;
    position relative;
    margin-top: 40px;

  .footer-content {
    padding: 10px 0 10px 0
  }

  footer {
    margin-top: 0px;
    background-color: #CAD5DB;
    padding: 0px !important ;
  }

  strong {
    font-weight: 500;
  }

  .screen-title {
    font-size: 1.25em;
    margin-bottom: 20px;
    position:absolute !important;
    left: 40px;
    top: -8px;
  }

  .buttons-top-crud {
    margin-top: 5px;
    margin-bottom: -3px;
  }

  .tooltip {
    position: relative;
    display: inline-block;
    cursor: pointer;
  }

  .tooltip:hover::after {
    content: attr(data-tooltip);
    position: absolute;
    background-color: #333;
    color: #fff;
    padding: 5px;
    border-radius: 5px;
    bottom: calc(100% + 4px);
    white-space: nowrap;
    animation: tool-tip-animation 0.5s forwards;
    pointer-events: none;
    opacity: 0.8;
    z-index: 9999999;
  }

  @keyframes tool-tip-animation {
    from {
      opacity: 0;
      transform: translate3d(-50%, 20px, 0);
      transition: 0.3s;
    }
    to {
      opacity: 0.8;
      transform: translate3d(-50%, 0, 0);
    }

  }
}

</style>
